// Даёт this.$addCleanup / this.$makeAborter / this.$killAll и флаг this._alive

import {reaper} from "../utils/rapper";

export default {
  install(Vue) {
    Vue.mixin({
      data() {
        return { _alive: true }
      },
      created() {
        this.$addCleanup   = (fn)  => reaper.add(fn)
        this.$addCancelable = (t)  => reaper.add(() => { try { t && t.cancel && t.cancel() } catch(e){} })
        this.$makeAborter  = ()    => reaper.makeAborter()
        this.$killAll      = ()    => reaper.killAll()
      },
      beforeDestroy() {
        this._alive = false
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/plugins/autoCleanup.js